import { DocumentType } from './document-type.enum';

/**
 * Represents all of the data associated with a single document in an order.
 */
export class Document {
    name: string;
    id: string;
    dateUploaded: Date;

    /**
     * Constructs a new Document object given all of the fields.
     */
    constructor(name: string, id: string, dateUploaded: Date) {
        this.name = name;
        this.id = id;
        this.dateUploaded = dateUploaded;
    }

    /**
     * Converts documents in JSON form to a Map<string, Document[]>
     *
     * @param docJson documents in JSON form
     *
     * @return the new map of Documents
     */
    static jsonToDocuments(docJson: object): Map<string, Document[]> {
        const docs = new Map<string, Document[]>();
        if (docJson === undefined) {
            return docs;
        }
        Object.values(DocumentType).forEach((type: string) => {
            const docArr: Document[] = [];
            if (docJson[type]) {
                docJson[type].forEach((doc) => {
                    docArr.push(new Document(doc.name, doc.id, new Date(doc.dateUploaded)));
                });
            }
            docs.set(type, docArr);
        });
        return docs;
    }
}
